import { apiCall } from './gqlClient';

const GETPAYMENTOPTIONS_QUERY = `
  query getPaymentOptions($providerId: Int) {
    getPaymentOptions(providerId: $providerId)
    {
      id
			providerId
			serviceOnsite
			serviceOnline
			serviceMembership
			courseOnsite
			courseOnline
			courseMembership
			membershipOnsite
			membershipOnline
			onlineDiscount
			acceptNonCustomerBookings
      ...fragments
    }
  }`;

export const getPaymentOptionsApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETPAYMENTOPTIONS_QUERY, variables: {providerId}, fragments });

const SHOWPAYMENTBUTTONSCUSTOMER_QUERY = `
  query showPaymentButtonsCustomer($providerId: Int!, $serviceId: Int, $reservationDate: DateTime, $sessions: [Int], $membershipId: Int) {
    showPaymentButtonsCustomer(providerId: $providerId, serviceId: $serviceId, reservationDate: $reservationDate, sessions: $sessions, membershipId: $membershipId)
    {
      payOnsite
			payOnline
			payWithMembership
      ...fragments
    }
  }`;

export const showPaymentButtonsCustomerApiCall = async ({providerId, serviceId, reservationDate, sessions, membershipId}, fragments = null) => apiCall({ query: SHOWPAYMENTBUTTONSCUSTOMER_QUERY, variables: {providerId, serviceId, reservationDate, sessions, membershipId}, fragments });

const SHOWPAYMENTBUTTONSPROVIDER_QUERY = `
  query showPaymentButtonsProvider($serviceId: Int, $membershipId: Int, $userId: Int, $customerId: Int, $reservationDate: DateTime, $sessions: [Int]) {
    showPaymentButtonsProvider(serviceId: $serviceId, membershipId: $membershipId, userId: $userId, customerId: $customerId, reservationDate: $reservationDate, sessions: $sessions)
    {
      payOnsite
			payOnline
			payWithMembership
      ...fragments
    }
  }`;

export const showPaymentButtonsProviderApiCall = async ({serviceId, membershipId, userId, customerId, reservationDate, sessions}, fragments = null) => apiCall({ query: SHOWPAYMENTBUTTONSPROVIDER_QUERY, variables: {serviceId, membershipId, userId, customerId, reservationDate, sessions}, fragments });

const UPDATEPAYMENTOPTIONS_QUERY = `
  mutation updatePaymentOptions($request: PaymentOptionsInput!) {
    updatePaymentOptions(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updatePaymentOptionsApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEPAYMENTOPTIONS_QUERY, variables: {request}, fragments });
